import React, { useContext } from "react";
import PropTypes from "prop-types";
import Card from "components/common/Card";
import * as S from "./style";
import Text from "components/common/Text";
import * as Constant from "constant";
import { ThemeContext } from "helpers/contexts.js";
import Avatar from "components/common/Avatar";

InfoCard.propTypes = {
  primaryText: PropTypes.string.isRequired,
  secondaryText: PropTypes.array,
  imgSrc: PropTypes.string,
};

InfoCard.defaultProps = {};

function InfoCard(props) {
  const theme = useContext(ThemeContext);

  return (
    <S.CardWrapper>
      <Card
        radius={Constant.RADIUS_SIZE.small}
        withBorder={true}
        shadow={Constant.SHADOW.shadow2}
        bgColor={theme.colors.white}
      >
        <S.ContentContainer>
          <S.AvatarContainer>
            <Avatar
              label={props.primaryText}
              size={Constant.SIZE.xxl}
              imgSrc={props.imgSrc}
            ></Avatar>
          </S.AvatarContainer>
          <S.TextSection>
            <Text
              size={Constant.SIZE.medium}
              color={theme.colors.gray.charcoal}
              ellipsis={true}
            >
              {props.primaryText}
            </Text>
            {props.secondaryText && props.secondaryText.length > 0
              ? props.secondaryText.map((text) => {
                  return (
                    <Text
                      size={Constant.SIZE.small}
                      color={theme.colors.gray.gray600}
                      ellipsis={true}
                    >
                      {text}
                    </Text>
                  );
                })
              : ""}
          </S.TextSection>
        </S.ContentContainer>
      </Card>
    </S.CardWrapper>
  );
}

export default InfoCard;
